<header class="lg:flex xl:flex p-4 bg-es-blue justify-between items-center border-t-4 border-es-orange">
  <a>
    <img src="assets/svgs/brands/PR/header-logo.svg">
  </a>
</header>

<div class="landing-wrapper relative">
  <div class="content">
    <h2 class="main-title">Sign Up in the Plymouth Rock App</h2>
    <div class="subtitle">
      <p *ngIf="!isMobile()">Our app is the fastest, easiest way to manage your policy! After downloading the app with the QR code below, enter your date of birth and create a password — that’s it!
        <br>You’ll instantly gain access to your policy and all its features.
      </p>
      <p *ngIf="isMobile()">Our app is the fastest, easiest way to manage your policy.
        <br><br>After downloading the app, <br> enter your date of birth and create a password — that's it!
      </p>
    </div>

    <div class="qr-instructions" *ngIf="!isMobile()">
      <div class="qr-code">
        <div id="qrCodeContainer"></div>
      </div>
      <div class="download-instructions">
        <h3>To download the PR app</h3>
        <ol>
          <li>1. Open your phone’s camera</li>
          <li>2. Point the camera at the QR code</li>
          <li>3. Tap the prompt to download</li>
        </ol>
      </div>
    </div>

    <div class="download-btn" *ngIf="isMobile()">
      <button class="es-btn-primary" (click)="openStore()">Download App</button>
    </div>

    <div class="go-mobile-wrapper">
      <div class="app-features">
        <div class="app-features-title">
          <h3>Go Mobile</h3>
          <img src="/assets/png/blue-mobile.png">
        </div>
        <ul>
          <li>Make Policy Changes</li>
          <li>Carry Digital ID Cards</li>
          <li>Manage Payment Preferences</li>
          <li>Make Payments</li>
          <li>File &amp; Manage Claims</li>
        </ul>
      </div>
      <div class="app-image">
        <img src="assets/png/mobile-app-ui.png" alt="App Preview">
      </div>
    </div>

  </div>
  <prcins-footer></prcins-footer>
</div>



